export function showValue(value: unknown): string {
    if (value === null || value === undefined || value === '') return '-';
    return String(value);
}

export function formatName(value: string): string {
    const text = showValue(value);

    if (text === '-') return text;

    return text
        .toLowerCase()
        .split(/\s+/)
        .map(word => word[0].toUpperCase() + word.slice(1))
        .join(' ');
}

export function boldSingleQuotedText(message: string): string {
    const pattern = /'([^']+)'/g;
    let result = '';
    let lastIndex = 0;
    let match: RegExpExecArray | null;

    while ((match = pattern.exec(message)) !== null) {
        result += escapeHtml(message.slice(lastIndex, match.index));
        result += `'<strong>${escapeHtml(match[1])}</strong>'`;
        lastIndex = pattern.lastIndex;
    }

    result += escapeHtml(message.slice(lastIndex));
    return result;
}

export function getErrorMessage(err: any, fallback: string): string {
    const message =
        err?.error?.description ||
        err?.error?.message ||
        err?.description ||
        err?.message ||
        fallback;

    return String(message).trim() || fallback;
}

export function escapeHtml(value: string): string {
    return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}
